<template>
  <div class="columns">
    <div v-if="markIt" class="column is-1">
      <Checkbox v-model="marked" :checked="marked" checkStyle="border-black" />
    </div>
    <div class="column">
      <b>תאריך עדכון: </b>
      {{ time_helper.makeTimeReadable(offer.updated_at) }},
      <b>נשלח ב: </b>
      {{ time_helper.makeTimeReadable(offer.sent_at) }},
      <b>משרה: </b>
      {{ offer.position.title }}
      <div class="is-flex mt-2">
        <b class="ml-3">הודעה:</b>
        <Message :payload="offer" :additional_data="{ resource_type: 'Offer', endpoint: '/offers/', headers: 'admin_headers' }"></Message>
      </div>
      <div class="mt-3">
        <b>סטטוס משרה: </b> {{ offer.position.status }}, <b>שם חברה: </b>{{ offer.position.company.name }}
      </div>
    </div>
    <div class="column is-4">
      <OfferStatus class="is-pulled-left" :payload="offer"></OfferStatus>
    </div>
  </div>
</template>
<script>
import TimeHelper from '@/custom/classes/time_helper.js'
import Message from '@/components/Message'
import Checkbox from '@/components/Checkbox'
import OfferStatus from '@/components/OfferStatus'
export default {
  name: 'cv-color-alert-message',
  components: {
    Message,
    OfferStatus,
    Checkbox
  },
  props: {
    offer: {
      type: Object
    },
    markIt: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      time_helper: new TimeHelper(),
      marked: false
    }
  },
  watch: {
    marked () {
      this.$emit('updateMark', this.offer.id, this.marked)
    }
  }
}
</script>
